"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("./actions");
exports.default = (function (state, action) {
    if (state === void 0) { state = {
        isFetching: false,
        data: {},
        error: "",
    }; }
    switch (action.type) {
        case actions_1.PERFORM_SEARCH.REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case actions_1.PERFORM_SEARCH.RECEIVE:
            return __assign(__assign({}, state), { isFetching: false, data: action.data, error: "" });
        case actions_1.PERFORM_SEARCH.ERROR:
            return __assign(__assign({}, state), { isFetching: false, error: action.message });
        default:
            return state;
    }
});
